import { TableRow, TableRowCell } from './styled';
import { Text, useTheme } from '@simplywallst/ui-core';
import { SymbolCell } from './SymbolCell';
import type { DividendHoldingItem } from '../../../types/portfolioDividend';
import LockSolid from '@simplywallst/ui-core/icons/LockSolid';
import { formatCurrencyToScaleTruncated } from '@/utilities/portfolio/formatValue';

interface Props {
  holding: DividendHoldingItem;
  isAnalysisRestricted?: boolean;
  currencyISO: string;
}

export const HoldingRow = ({
  holding,
  isAnalysisRestricted,
  currencyISO,
}: Props) => {
  const theme = useTheme();

  const company = {
    tickerSymbol: holding.tickerSymbol,
    name: holding.name,
    canonicalURL: holding.canonicalURL,
  };

  const formattedPayment = formatCurrencyToScaleTruncated(
    holding.payment,
    currencyISO
  );
  const isRestricted = isAnalysisRestricted || holding.isAnalysisRestricted;

  return (
    <>
      <TableRow tabIndex={0}>
        <SymbolCell company={company} />

        <TableRowCell>
          {isRestricted ? (
            <LockSolid
              aria-label="Blocked content"
              fill={theme.color.chart05RGBA(0.3)}
            />
          ) : (
            <Text typography="tiny" color="textSofter" lineClamp={1}>
              {formattedPayment}
            </Text>
          )}
        </TableRowCell>
      </TableRow>
    </>
  );
};
